export enum GridActionTypes {
  SET_FILTER = 'SET_FILTER',
  ADD_VIEW = 'ADD_VIEW',
  SET_VIEW = 'SET_VIEW',
  DELETE_VIEW = 'DELETE_VIEW',
  CLEAR_VIEWS = 'CLEAR_VIEWS',
  SET_ORDER = 'SET_ORDER',
  SET_PAGE = 'SET_PAGE',
  GET_GRID = 'GET_GRID',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  CLEAR_ORDER = 'CLEAR_ORDER',
  CLEAR_PAGE = 'CLEAR_PAGE',
  CLEAR_GRID = 'CLEAR_GRID',
  CLEAR_ALL_GRIDS = 'CLEAR_ALL_GRIDS',
  CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS',
  SET_COLUNAS = 'SET_COLUNAS'
}
